import { Injectable } from '@angular/core';
import { TranslateCompiler } from '@ngx-translate/core';

/**
 * Token de año soportado en los archivos de i18n:
 * `{currentYear}` o `{currentYear-N}` (año actual menos N).
 * Usa llaves simples para no chocar con la interpolación
 * runtime de ngx-translate (`{{param}}`).
 */
const YEAR_TOKEN = /\{currentYear(?:-(\d+))?\}/g;

/**
 * Compilador de traducciones que resuelve tokens de año al
 * momento de cargar cada archivo de i18n. Permite textos que
 * se actualizan solos año a año (ej. "parcial {currentYear} y
 * cierres de {currentYear-1}") sin pasar params en cada
 * `| translate` del código.
 */
@Injectable()
export class YearPlaceholderTranslateCompiler extends TranslateCompiler {
  compile(value: string, _lang: string): string {
    return this.replaceYearTokens(value);
  }

  compileTranslations(translations: unknown, _lang: string): unknown {
    return this.compileNode(translations);
  }

  private compileNode(node: unknown): unknown {
    if (typeof node === 'string') {
      return this.replaceYearTokens(node);
    }
    if (node !== null && typeof node === 'object') {
      return Object.fromEntries(
        Object.entries(node as Record<string, unknown>).map(
          ([key, value]) => [key, this.compileNode(value)]
        )
      );
    }
    return node;
  }

  private replaceYearTokens(value: string): string {
    const currentYear = new Date().getFullYear();
    return value.replace(YEAR_TOKEN, (_match, offset?: string) =>
      String(currentYear - (offset ? Number(offset) : 0))
    );
  }
}
